import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./forms/Footer";
import HamburgerMenu from "./HamburgerMenu";
import Analytics from "./Analytics.js";
import "./LayOut.css";


const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // fix to move graph

  return (
    <>
      <Analytics
        apiEndpoint={`${process.env.REACT_APP_API_BASE_URL}/api/analytics`}
        enableLogging={true}
        path={location.pathname}
      />
      <HamburgerMenu />
      <NavBar />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;